import { type KanaType, TypeOfKana } from '../types/kana';

const katakana: KanaType[] = [
  {
    id: 'k_a',
    pronunciation: 'A',
    kana: 'ア',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'k_i',
    pronunciation: 'I',
    kana: 'イ',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'k_u',
    pronunciation: 'U',
    kana: 'ウ',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'k_e',
    pronunciation: 'E',
    kana: 'エ',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'k_o',
    pronunciation: 'O',
    kana: 'オ',
    type: TypeOfKana.basic,
    group: 'basic',
  },
  {
    id: 'k_ka',
    pronunciation: 'KA',
    kana: 'カ',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'k_ki',
    pronunciation: 'KI',
    kana: 'キ',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'k_ku',
    pronunciation: 'KU',
    kana: 'ク',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'k_ke',
    pronunciation: 'KE',
    kana: 'ケ',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'k_ko',
    pronunciation: 'KO',
    kana: 'コ',
    type: TypeOfKana.basic,
    group: 'k',
  },
  {
    id: 'k_sa',
    pronunciation: 'SA',
    kana: 'サ',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'k_shi',
    pronunciation: 'SHI',
    kana: 'シ',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'k_su',
    pronunciation: 'SU',
    kana: 'ス',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'k_se',
    pronunciation: 'SE',
    kana: 'セ',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'k_so',
    pronunciation: 'SO',
    kana: 'ソ',
    type: TypeOfKana.basic,
    group: 's',
  },
  {
    id: 'k_ta',
    pronunciation: 'TA',
    kana: 'タ',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'k_chi',
    pronunciation: 'CHI',
    kana: 'チ',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'k_tsu',
    pronunciation: 'TSU',
    kana: 'ツ',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'k_te',
    pronunciation: 'TE',
    kana: 'テ',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'k_to',
    pronunciation: 'TO',
    kana: 'ト',
    type: TypeOfKana.basic,
    group: 't',
  },
  {
    id: 'k_na',
    pronunciation: 'NA',
    kana: 'ナ',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'k_ni',
    pronunciation: 'NI',
    kana: 'ニ',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'k_nu',
    pronunciation: 'NU',
    kana: 'ヌ',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'k_ne',
    pronunciation: 'NE',
    kana: 'ネ',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'k_no',
    pronunciation: 'NO',
    kana: 'ノ',
    type: TypeOfKana.basic,
    group: 'n',
  },
  {
    id: 'k_ha',
    pronunciation: 'HA',
    kana: 'ハ',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'k_hi',
    pronunciation: 'HI',
    kana: 'ヒ',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'k_fu',
    pronunciation: 'FU',
    kana: 'フ',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'k_he',
    pronunciation: 'HE',
    kana: 'ヘ',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'k_ho',
    pronunciation: 'HO',
    kana: 'ホ',
    type: TypeOfKana.basic,
    group: 'h',
  },
  {
    id: 'k_ma',
    pronunciation: 'MA',
    kana: 'マ',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'k_mi',
    pronunciation: 'MI',
    kana: 'ミ',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'k_mu',
    pronunciation: 'MU',
    kana: 'ム',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'k_me',
    pronunciation: 'ME',
    kana: 'メ',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'k_mo',
    pronunciation: 'MO',
    kana: 'モ',
    type: TypeOfKana.basic,
    group: 'm',
  },
  {
    id: 'k_ya',
    pronunciation: 'YA',
    kana: 'ヤ',
    type: TypeOfKana.basic,
    group: 'y',
  },
  {
    id: 'k_yu',
    pronunciation: 'YU',
    kana: 'ユ',
    type: TypeOfKana.basic,
    group: 'y',
  },
  {
    id: 'k_yo',
    pronunciation: 'YO',
    kana: 'ヨ',
    type: TypeOfKana.basic,
    group: 'y',
  },
  {
    id: 'k_ra',
    pronunciation: 'RA',
    kana: 'ラ',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'k_ri',
    pronunciation: 'RI',
    kana: 'リ',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'k_ru',
    pronunciation: 'RU',
    kana: 'ル',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'k_re',
    pronunciation: 'RE',
    kana: 'レ',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'k_ro',
    pronunciation: 'RO',
    kana: 'ロ',
    type: TypeOfKana.basic,
    group: 'r',
  },
  {
    id: 'k_wa',
    pronunciation: 'WA',
    kana: 'ワ',
    type: TypeOfKana.basic,
    group: 'w',
  },
  {
    id: 'k_wo',
    pronunciation: '(W)O',
    kana: 'ヲ',
    type: TypeOfKana.basic,
    group: 'w',
  },
  {
    id: 'k_n',
    pronunciation: 'N',
    kana: 'ン',
    type: TypeOfKana.basic,
    group: 'n/m',
  },
  {
    id: 'k_ga',
    pronunciation: 'GA',
    kana: 'ガ',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'k_gi',
    pronunciation: 'GI',
    kana: 'ギ',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'k_gu',
    pronunciation: 'GU',
    kana: 'グ',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'k_ge',
    pronunciation: 'GE',
    kana: 'ゲ',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'k_go',
    pronunciation: 'GO',
    kana: 'ゴ',
    type: TypeOfKana.tenten,
    group: 'g',
  },
  {
    id: 'k_za',
    pronunciation: 'ZA',
    kana: 'ザ',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'k_zi',
    pronunciation: 'JI',
    kana: 'ジ',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'k_zu',
    pronunciation: 'ZU',
    kana: 'ズ',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'k_ze',
    pronunciation: 'ZE',
    kana: 'ゼ',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'k_zo',
    pronunciation: 'ZO',
    kana: 'ゾ',
    type: TypeOfKana.tenten,
    group: 'z',
  },
  {
    id: 'k_da',
    pronunciation: 'DA',
    kana: 'ダ',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'k_di',
    pronunciation: 'DI',
    kana: 'ヂ',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'k_du',
    pronunciation: 'DU',
    kana: 'ヅ',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'k_de',
    pronunciation: 'DE',
    kana: 'デ',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'k_do',
    pronunciation: 'DO',
    kana: 'ド',
    type: TypeOfKana.tenten,
    group: 'd',
  },
  {
    id: 'k_ba',
    pronunciation: 'BA',
    kana: 'バ',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'k_bi',
    pronunciation: 'BI',
    kana: 'ビ',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'k_bu',
    pronunciation: 'BU',
    kana: 'ブ',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'k_be',
    pronunciation: 'BE',
    kana: 'ベ',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'k_bo',
    pronunciation: 'BO',
    kana: 'ボ',
    type: TypeOfKana.tenten,
    group: 'b',
  },
  {
    id: 'k_pa',
    pronunciation: 'PA',
    kana: 'パ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'k_pi',
    pronunciation: 'PI',
    kana: 'ピ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'k_pu',
    pronunciation: 'PU',
    kana: 'プ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'k_pe',
    pronunciation: 'PE',
    kana: 'ペ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'k_po',
    pronunciation: 'PO',
    kana: 'ポ',
    type: TypeOfKana.tenten,
    group: 'p',
  },
  {
    id: 'k_kya',
    pronunciation: 'KYA',
    kana: 'キャ',
    type: TypeOfKana.yoon,
    group: 'ky',
  },
  {
    id: 'k_kyu',
    pronunciation: 'KYU',
    kana: 'キュ',
    type: TypeOfKana.yoon,
    group: 'ky',
  },
  {
    id: 'k_kyo',
    pronunciation: 'KYO',
    kana: 'キョ',
    type: TypeOfKana.yoon,
    group: 'ky',
  },
  {
    id: 'k_sha',
    pronunciation: 'SHA',
    kana: 'シャ',
    type: TypeOfKana.yoon,
    group: 'sh',
  },
  {
    id: 'k_shu',
    pronunciation: 'SHU',
    kana: 'シュ',
    type: TypeOfKana.yoon,
    group: 'sh',
  },
  {
    id: 'k_sho',
    pronunciation: 'SHO',
    kana: 'ショ',
    type: TypeOfKana.yoon,
    group: 'sh',
  },
  {
    id: 'k_cha',
    pronunciation: 'CHA',
    kana: 'チャ',
    type: TypeOfKana.yoon,
    group: 'ch',
  },
  {
    id: 'k_chu',
    pronunciation: 'CHU',
    kana: 'チュ',
    type: TypeOfKana.yoon,
    group: 'ch',
  },
  {
    id: 'k_cho',
    pronunciation: 'CHO',
    kana: 'チョ',
    type: TypeOfKana.yoon,
    group: 'ch',
  },
  {
    id: 'k_nya',
    pronunciation: 'NYA',
    kana: 'ニャ',
    type: TypeOfKana.yoon,
    group: 'ny',
  },
  {
    id: 'k_nyu',
    pronunciation: 'NYU',
    kana: 'ニュ',
    type: TypeOfKana.yoon,
    group: 'ny',
  },
  {
    id: 'k_nyo',
    pronunciation: 'NYO',
    kana: 'ニョ',
    type: TypeOfKana.yoon,
    group: 'ny',
  },
  {
    id: 'k_hya',
    pronunciation: 'HYA',
    kana: 'ヒャ',
    type: TypeOfKana.yoon,
    group: 'hy',
  },
  {
    id: 'k_hyu',
    pronunciation: 'HYU',
    kana: 'ヒュ',
    type: TypeOfKana.yoon,
    group: 'hy',
  },
  {
    id: 'k_hyo',
    pronunciation: 'HYO',
    kana: 'ヒョ',
    type: TypeOfKana.yoon,
    group: 'hy',
  },
  {
    id: 'k_mya',
    pronunciation: 'MYA',
    kana: 'ミャ',
    type: TypeOfKana.yoon,
    group: 'my',
  },
  {
    id: 'k_myu',
    pronunciation: 'MYU',
    kana: 'ミュ',
    type: TypeOfKana.yoon,
    group: 'my',
  },
  {
    id: 'k_myo',
    pronunciation: 'MYO',
    kana: 'ミョ',
    type: TypeOfKana.yoon,
    group: 'my',
  },
  {
    id: 'k_rya',
    pronunciation: 'RYA',
    kana: 'リャ',
    type: TypeOfKana.yoon,
    group: 'ry',
  },
  {
    id: 'k_ryu',
    pronunciation: 'RYU',
    kana: 'リュ',
    type: TypeOfKana.yoon,
    group: 'ry',
  },
  {
    id: 'k_ryo',
    pronunciation: 'RYO',
    kana: 'リョ',
    type: TypeOfKana.yoon,
    group: 'ry',
  },
  {
    id: 'k_gya',
    pronunciation: 'GYA',
    kana: 'ガャ',
    type: TypeOfKana.yoon,
    group: 'gy',
  },
  {
    id: 'k_gyu',
    pronunciation: 'GYU',
    kana: 'ガュ',
    type: TypeOfKana.yoon,
    group: 'gy',
  },
  {
    id: 'k_gyo',
    pronunciation: 'GYO',
    kana: 'ガョ',
    type: TypeOfKana.yoon,
    group: 'gy',
  },
  {
    id: 'k_ja',
    pronunciation: 'JA',
    kana: 'ジャ',
    type: TypeOfKana.yoon,
    group: 'j',
  },
  {
    id: 'k_ju',
    pronunciation: 'JU',
    kana: 'ジュ',
    type: TypeOfKana.yoon,
    group: 'j',
  },
  {
    id: 'k_jo',
    pronunciation: 'JO',
    kana: 'ジョ',
    type: TypeOfKana.yoon,
    group: 'j',
  },
  {
    id: 'k_bya',
    pronunciation: 'BYA',
    kana: 'ビャ',
    type: TypeOfKana.yoon,
    group: 'by',
  },
  {
    id: 'k_byu',
    pronunciation: 'BYU',
    kana: 'ビュ',
    type: TypeOfKana.yoon,
    group: 'by',
  },
  {
    id: 'k_byo',
    pronunciation: 'BYO',
    kana: 'ビョ',
    type: TypeOfKana.yoon,
    group: 'by',
  },
  {
    id: 'k_pya',
    pronunciation: 'PYA',
    kana: 'ポャ',
    type: TypeOfKana.yoon,
    group: 'py',
  },
  {
    id: 'k_pyu',
    pronunciation: 'PYU',
    kana: 'ポュ',
    type: TypeOfKana.yoon,
    group: 'py',
  },
  {
    id: 'k_pyo',
    pronunciation: 'PYO',
    kana: 'ポョ',
    type: TypeOfKana.yoon,
    group: 'py',
  },
];

export default katakana;
